import { Stack } from '@mui/material'
import { SimpleSelect } from '@workwave-tidal/core/components'
import { useRecurrenceType } from '../../../providers/StateProvider'
import { useOptions } from './useOptions'
import { useOnChange } from './useOnChange'
import { useTexts } from './useTexts'

export type RecurrenceTypeDropdownProps = {
  testId?: string
}

export function RecurrenceTypeDropdown(props: RecurrenceTypeDropdownProps) {
  const { testId = 'RecurrenceTypeDropdown' } = props
  const type = useRecurrenceType()
  const options = useOptions()
  const onChange = useOnChange()
  const texts = useTexts()

  return (
    <Stack data-testid={testId}>
      <SimpleSelect
        label={texts.label}
        name="recurrenceType"
        value={type}
        options={options}
        onChange={onChange}
      />
    </Stack>
  )
}
